<div
  class="viewport"
  [style.transform]="translateX"
  [style.transition]="panning ? 'none' : slowTransition"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)"
>
  <ng-content></ng-content>
</div>
